import {getUserInfo} from '@/service';
import Cookies from 'js-cookie';
import {dotDomain} from '@/global';

export const setCorpId = (corp) => {
  Cookies.set(`appCorpId@-2`, corp.corpId, {domain: dotDomain, expires: 100000});
  corp.applicationList.forEach((item)=>{
    Cookies.set(`appCorpId@${item.appId}`, corp.corpId, {domain: dotDomain, expires: 100000});
  });
};

export const getCorpId = () => {
  try {
    return Cookies.get(`appCorpId@-2`);
  } catch (e) {
    console.error(e);
    return '';
  }
};

export default {
  getCorpId: getCorpId(),
  namespaced: true,
  state: {
    user: {},
    userAuth: {},
    applicationList: null,
    corporationList: [],
    currentCorp: {corpName: '未绑定企业'},
    isCorpLogin: false, // 是否是企业登录
  },
  mutations: {
    setUser(state, value) {
      state.user = value;
    },
    setUserAuth(state, value) {
      state.userAuth = value;
    },
    setApplicationList(state, value) {
      state.applicationList = value;
    },
    setCorporationList(state, value) {
      state.corporationList = value;
    },
    setCurrentCorp(state, value) {
      state.currentCorp = value;
    },
    setIsCorpLogin(state, value) {
      state.isCorpLogin = value;
    },
  },
  actions: {
    async init({commit}) {
      return getUserInfo().then(({data: {user, userAuth, corporationList, corpAccount}})=> {
        commit('setUser', user||{});
        commit('setUserAuth', userAuth||{});
        commit('setCorporationList', corporationList||[]);
        commit('setIsCorpLogin', corpAccount);
        const corpId = getCorpId();
        if (corporationList.length !== 0) {
          let currentCorp = corporationList.find((item) => item.corpId === parseInt(corpId));
          if (!currentCorp) {
            currentCorp = corporationList.find((item) => item.primaryCorp);
            if (!currentCorp) {
              currentCorp = corporationList[0];
            }
          }
          setCorpId(currentCorp);
          commit('setCurrentCorp', currentCorp);
          commit('setApplicationList', currentCorp.applicationList);
        } else {
          commit('setCurrentCorp', {corpName: '未绑定企业'});
          commit('setApplicationList', []);
        }
      });
    },
    async setCurrentCorpAndAppList({commit}, corp) {
      setCorpId(corp);
      commit('setCurrentCorp', corp||{});
      commit('setApplicationList', corp.applicationList || []);
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    userAuth(state) {
      return state.menuData;
    },
    applicationList(state) {
      return state.applicationList;
    },
    corporationList(state) {
      return state.corporationList;
    },
    currentCorp(state) {
      return state.currentCorp;
    },
    isCorpLogin(state) {
      return state.isCorpLogin;
    },
  },
};
